export default "__VITE_PUBLIC_ASSET__f318e1ab__"